import {
    CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES,
    CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR,
    EditPageItemNameEditorAction,
    OPEN_EDIT_PAGE_ITEM_NAME_EDITOR,
    SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS,
    UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE
} from '../../actions/editPageItemNameEditor';
import { getDefaultEditPageItemNameEditorState } from '../../service/EditPageItemNameEditor/EditPageItemNameEditor';
import { EditPageItemNameEditorsState } from '../../typings/editPageItemNameEditor';
import { State } from '../../typings/state';

export function editPageItemNameEditor(
    state: EditPageItemNameEditorsState = {},
    action: EditPageItemNameEditorAction,
    fullState: State
): EditPageItemNameEditorsState {
    switch (action.type) {
        case OPEN_EDIT_PAGE_ITEM_NAME_EDITOR: {
            const editorId = action.editorId;
            const editorState =
                state[editorId] || getDefaultEditPageItemNameEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    value: action.value,
                    isVisible: true
                }
            };
        }

        case CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR: {
            const editorId = action.editorId;
            const editorState =
                state[editorId] || getDefaultEditPageItemNameEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    isVisible: false
                }
            };
        }

        case UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE: {
            const editorId = action.editorId;
            const editorState =
                state[editorId] || getDefaultEditPageItemNameEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    value: action.value,
                    errors: []
                }
            };
        }

        case SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS: {
            const editorId = action.editorId;
            const editorState =
                state[editorId] || getDefaultEditPageItemNameEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    isVisible: true,
                    errors: action.errors
                }
            };
        }

        case CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES: {
            const editorId = action.editorId;

            return {
                ...state,
                [editorId]: getDefaultEditPageItemNameEditorState()
            };
        }

        default:
            return state;
    }
}
